export default "__VITE_ASSET__f5d2a7d2__"